import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PaymentCancelPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm text-center"
      >
        <Link
          to="/"
          className="font-serif text-2xl tracking-widest uppercase text-primary block mb-12"
        >
          Lanre Savage
        </Link>

        <div className="w-20 h-20 bg-light rounded-full flex items-center justify-center mx-auto mb-8">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round"
            strokeLinejoin="round" className="text-nude">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>

        <h1 className="font-serif text-4xl text-primary mb-4">
          Payment Cancelled
        </h1>
        <p className="text-xs text-nude tracking-wide leading-relaxed mb-10">
          Your payment was cancelled. Your cart items have been saved and
          you can complete your purchase at any time.
        </p>

        <div className="space-y-3">
          <Link to="/checkout" className="btn-primary block">
            Return to Checkout
          </Link>
          <Link to="/shop" className="btn-secondary block">
            Continue Shopping
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;